import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DetailProcessstepsComponent } from './detail-processsteps.component';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { FormioModule } from '@formio/angular';
import { TranslateModule } from '@ngx-translate/core';
import { AngularFrameworkModule } from 'sp-office365-framework';
import { TableTaskModule } from '../../task/table-task/table-task.module';
import { TableTasktemplateModule } from '../../tasktemplate/table-tasktemplate/table-tasktemplate.module';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
    declarations: [DetailProcessstepsComponent],
    imports: [
        CommonModule,
        AngularFrameworkModule,
        TranslateModule,
        MatTabsModule,
        MatSnackBarModule,
        MatToolbarModule,
        MatIconModule,
        TableTaskModule,
        FormioModule,
        FormioModule,
        TableTasktemplateModule,
        DragDropModule,
    ],
})
export class DetailProcessstepsModule {}
